import { PromotionInfo } from "../promotion/promotion.model";

export enum SubtransactionType {
  // Draws
  DrawDisbursement                =   0,
  DrawFee                         =   1,

  // Payments
  PaymentPrincipal                =   2,
  PaymentInterest                 =   3,

  // Transfers
  InterestCharge                  =   4,
  PrincipalTransfer               =   8,
  InterestTransfer                =   9,
  FeeBalanceTransfer              =  10,
  TotalFeesTransfer               =  11,
  TotalPrincipalPaidTransfer      =  12,

  // Premiums and Payoffs
  LitigationCostProtectionPremium =  15,
  ThirdPartyPayoff                =  23,

  // Fees
  RenewalFeeCash                  =   5,
  RenewalFeeDeferred              =  25,
  WireFeeCash                     =  26,
  WireFeeDeferred                 =   6,
  LateFeeCash                     =   7,
  LateFeeDeferred                 =  27,
  OriginationFeeCash              =  33,
  OriginationFeeDeferred          =  13,
  MaintenanceFeeCash              =  14,
  MaintenanceFeeDeferred          =  34,
  UCCFilingFeeCash                =  16,
  UCCFilingFeeDeferred            =  36,
  StoppedPaymentFeeCash           =  17,
  StoppedPaymentFeeDeferred       =  37,
  NSFFeeCash                      =  18,
  NSFFeeDeferred                  =  38,
  ModificationFeeCash             =  19,
  ModificationFeeInstallments     =  20,
  ModificationFeeDeferred         =  21,
  StackingFeeCash                 =  22,
  StackingFeeDeferred             =  42,
  AdministrativeFeeCash           =  43,
  AdministrativeFeeDeferred       =  44,
  ServicingFeeCash                =  45,
  ServicingFeeDeferred            =  46,
  UCCEnforcementFeeCash           =  47,
  UCCEnforcementFeeDeferred       =  49,
  BankAccountChangeFeeCash        =  50,
  BankAccountChangeFeeDeferred    =  51,
  SubordinationFeeCash            =  52,
  SubordinationFeeDeferred        =  53,

  //Reversals and Balance Adjustments
  PrincipalAdjustment             =  54,
  TotalPrincipalPaidAdjustment    =  55,
  TotalPrincipalFundedAdjustment  =  56,
  InterestAdjustment              =  57,
  TotalInterestPaidAdjustment     =  58,
  TotalInterestChargedAdjustment  =  59,
  DeferredFeeAdjustment           =  60,
  TotalFeesAdjustment             =  61,
  CashFeeAdjustment               =  62
}

export const SubtransactionTypeInternalLabel = new Map<number, string>([
  // Draws
  [SubtransactionType.DrawDisbursement, 'Disbursed amount'],
  [SubtransactionType.DrawFee, 'Draw fee'],

  // Payments
  [SubtransactionType.PaymentPrincipal, 'Principal payment'],
  [SubtransactionType.PaymentInterest, 'Interest payment'],

  // Premiums and Payoffs
  [SubtransactionType.LitigationCostProtectionPremium, 'Litigation cost protection premium'],
  [SubtransactionType.ThirdPartyPayoff, 'Third party payoff'],

  // Fees
  [SubtransactionType.RenewalFeeCash, 'Renewal fee (cash)'],
  [SubtransactionType.RenewalFeeDeferred, 'Renewal fee (deferred)'],
  [SubtransactionType.WireFeeCash, 'Wire fee (cash)'],
  [SubtransactionType.WireFeeDeferred, 'Wire fee (deferred)'],
  [SubtransactionType.LateFeeCash, 'Late payment fee (cash)'],
  [SubtransactionType.LateFeeDeferred, 'Late payment fee (deferred)'],
  [SubtransactionType.OriginationFeeCash, 'Origination fee (cash)'],
  [SubtransactionType.OriginationFeeDeferred, 'Origination fee (deferred)'],
  [SubtransactionType.MaintenanceFeeCash, 'Maintenance fee (cash)'],
  [SubtransactionType.MaintenanceFeeDeferred, 'Maintenance fee (deferred)'],
  [SubtransactionType.UCCFilingFeeCash, 'UCC filing fee (cash)'],
  [SubtransactionType.UCCFilingFeeDeferred, 'UCC filing fee (deferred)'],
  [SubtransactionType.StoppedPaymentFeeCash, 'Stopped payment fee (cash)'],
  [SubtransactionType.StoppedPaymentFeeDeferred, 'Stopped payment fee (deferred)'],
  [SubtransactionType.NSFFeeCash, 'NSF fee (cash)'],
  [SubtransactionType.NSFFeeDeferred, 'NSF fee (deferred)'],
  [SubtransactionType.ModificationFeeCash, 'Modification fee (cash)'],
  [SubtransactionType.ModificationFeeInstallments, 'Modification fee (installments)'],
  [SubtransactionType.ModificationFeeDeferred, 'Modification fee (deferred)'],
  [SubtransactionType.StackingFeeCash, 'Stacking fee (cash)'],
  [SubtransactionType.StackingFeeDeferred, 'Stacking fee (deferred)'],
  [SubtransactionType.AdministrativeFeeCash, 'Administrative fee (cash)'],
  [SubtransactionType.AdministrativeFeeDeferred, 'Administrative fee (deferred)'],
  [SubtransactionType.ServicingFeeCash, 'Servicing fee (cash)'],
  [SubtransactionType.ServicingFeeDeferred, 'Servicing fee (deferred)'],
  [SubtransactionType.UCCEnforcementFeeCash, 'UCC enforcement or termination fee (cash)'],
  [SubtransactionType.UCCEnforcementFeeDeferred, 'UCC enforcement or termination fee (deferred)'],
  [SubtransactionType.BankAccountChangeFeeCash, 'Bank account change fee (cash)'],
  [SubtransactionType.BankAccountChangeFeeDeferred, 'Bank account change fee (deferred)'],
  [SubtransactionType.SubordinationFeeCash, 'Subordination fee (cash)'],
  [SubtransactionType.SubordinationFeeDeferred, 'Subordination fee (deferred)'],

  // Transfers
  [SubtransactionType.InterestCharge, 'Interest charge'],
  [SubtransactionType.PrincipalTransfer, 'Principal transfer'],
  [SubtransactionType.InterestTransfer, 'Interest transfer'],
  [SubtransactionType.FeeBalanceTransfer, 'Fee balance transfer'],
  [SubtransactionType.TotalFeesTransfer, 'Total fees transfer'],
  [SubtransactionType.TotalPrincipalPaidTransfer, 'Total principal paid transfer'],

  // Reversals and Balance Adjustments
  [SubtransactionType.PrincipalAdjustment, 'Principal adjustment'],
  [SubtransactionType.TotalPrincipalPaidAdjustment, 'Total principal paid adjustment'],
  [SubtransactionType.TotalPrincipalFundedAdjustment, 'Total principal funded adjustment'],
  [SubtransactionType.InterestAdjustment, 'Interest adjustment'],
  [SubtransactionType.TotalInterestPaidAdjustment, 'Total interest paid adjustment'],
  [SubtransactionType.TotalInterestChargedAdjustment, 'Total interest charged adjustment'],
  [SubtransactionType.DeferredFeeAdjustment, 'Deferred fee adjustment'],
  [SubtransactionType.TotalFeesAdjustment, 'Total fees adjustment'],
  [SubtransactionType.CashFeeAdjustment, 'Cash fee adjustment']
]);

export const SubtransactionTypeConsumerLabel = new Map<number, string>([
  // Draws
  [SubtransactionType.DrawDisbursement, 'Disbursed amount'],
  [SubtransactionType.DrawFee, 'Draw fee'],

  // Payments
  [SubtransactionType.PaymentPrincipal, 'Principal payment'],
  [SubtransactionType.PaymentInterest, 'Interest payment'],

  // Premiums and Payoffs
  [SubtransactionType.LitigationCostProtectionPremium, 'Litigation cost protection premium'],
  [SubtransactionType.ThirdPartyPayoff, 'Third party payoff'],

  // Fees
  [SubtransactionType.RenewalFeeCash, 'Renewal fee'],
  [SubtransactionType.RenewalFeeDeferred, 'Renewal fee'],
  [SubtransactionType.WireFeeCash, 'Wire fee'],
  [SubtransactionType.WireFeeDeferred, 'Wire fee'],
  [SubtransactionType.LateFeeCash, 'Late fee'],
  [SubtransactionType.LateFeeDeferred, 'Late fee'],
  [SubtransactionType.OriginationFeeCash, 'Origination fee'],
  [SubtransactionType.OriginationFeeDeferred, 'Origination fee'],
  [SubtransactionType.MaintenanceFeeCash, 'Maintenance fee'],
  [SubtransactionType.MaintenanceFeeDeferred, 'Maintenance fee'],
  [SubtransactionType.UCCFilingFeeCash, 'UCC filing fee'],
  [SubtransactionType.UCCFilingFeeDeferred, 'UCC filing fee'],
  [SubtransactionType.StoppedPaymentFeeCash, 'Stopped payment fee'],
  [SubtransactionType.StoppedPaymentFeeDeferred, 'Stopped payment fee'],
  [SubtransactionType.NSFFeeCash, 'NSF fee'],
  [SubtransactionType.NSFFeeDeferred, 'NSF fee'],
  [SubtransactionType.ModificationFeeCash, 'Modification fee'],
  [SubtransactionType.ModificationFeeInstallments, 'Modification fee'],
  [SubtransactionType.ModificationFeeDeferred, 'Modification fee'],
  [SubtransactionType.StackingFeeCash, 'Stacking fee'],
  [SubtransactionType.StackingFeeDeferred, 'Stacking fee'],
  [SubtransactionType.AdministrativeFeeCash, 'Administrative fee'],
  [SubtransactionType.AdministrativeFeeDeferred, 'Administrative fee'],
  [SubtransactionType.ServicingFeeCash, 'Servicing fee'],
  [SubtransactionType.ServicingFeeDeferred, 'Servicing fee'],

  // Transfers
  [SubtransactionType.InterestCharge, 'Interest charge'],
  [SubtransactionType.PrincipalTransfer, 'Principal transfer'],
  [SubtransactionType.InterestTransfer, 'Interest transfer'],
  [SubtransactionType.FeeBalanceTransfer, 'Fee balance transfer'],
  [SubtransactionType.TotalFeesTransfer, 'Total fees transfer'],
  [SubtransactionType.TotalPrincipalPaidTransfer, 'Total principal paid transfer'],

    // Reversals and Balance Adjustments
  [SubtransactionType.PrincipalAdjustment, 'Principal adjustment'],
  [SubtransactionType.TotalPrincipalPaidAdjustment, 'Total principal paid adjustment'],
  [SubtransactionType.TotalPrincipalFundedAdjustment, 'Total principal funded adjustment'],
  [SubtransactionType.InterestAdjustment, 'Interest adjustment'],
  [SubtransactionType.TotalInterestPaidAdjustment, 'Total interest paid adjustment'],
  [SubtransactionType.TotalInterestChargedAdjustment, 'Total interest charged adjustment'],
  [SubtransactionType.DeferredFeeAdjustment, 'Deferred fee adjustment'],
  [SubtransactionType.TotalFeesAdjustment, 'Total fees adjustment'],
  [SubtransactionType.CashFeeAdjustment, 'Cash fee adjustment']
]);

export class SubtransactionData {
  amount: number;
  type: SubtransactionType;
  display?: boolean;
}

export enum TransactionStatus {
  Pending = 0,
  Processed = 1,
  Rejected = 2,
  Canceled = 3,
  Approved = 4,
  Verified = 5,
  Complete = 6,
  Declined = 7,
  Abandoned = 8,
  OnHold = 9
}

export enum TransactionNextStatus {
  Rejected = TransactionStatus.Rejected,
  Approved = TransactionStatus.Approved,
}

export const TransactionStatusLabel = new Map<TransactionStatus, string>([
  [TransactionStatus.Pending, "Pending"],
  [TransactionStatus.Processed, "Processed"],
  [TransactionStatus.Rejected, "Rejected"],
  [TransactionStatus.Canceled, "Canceled"],
  [TransactionStatus.Approved, "Approved"],
  [TransactionStatus.Verified, "Verified"],
  [TransactionStatus.Complete, "Complete"],
  [TransactionStatus.Declined, "Declined"],
  [TransactionStatus.Abandoned, "Abandoned"],
  [TransactionStatus.OnHold, "On Hold"],
]);

export const TransactionStatusVerb = new Map<TransactionStatus, string>([
  [TransactionStatus.Pending, "Pending"],
  [TransactionStatus.Processed, "Process"],
  [TransactionStatus.Rejected, "Reject"],
  [TransactionStatus.Canceled, "Cancel"],
  [TransactionStatus.Approved, "Approve"],
  [TransactionStatus.Verified, "Verify"],
  [TransactionStatus.Complete, "Complete"],
  [TransactionStatus.Declined, "Decline"],
  [TransactionStatus.Abandoned, "Abandon"],
  [TransactionStatus.OnHold, "Hold"],
]);

export enum TransactionType {
  Draw = 0,
  Fee = 1,
  Payment = 2,
  BalanceTransfer = 3,
  Premium = 4,
  Payoff = 5,
  Reversal = 6,
  BalanceAdjustment = 7
}

export enum TransactionTypeString {
  Draw = "draw",
  Fee = "fee",
  Payment = "payment",
  BalanceTransfer = "balance-transfer",
  Premium = "premium",
  Payoff = 'payoff',
  Reversal = 'reversal',
  BalanceAdjustment = 'balance-adjustment'
}

export const TransactionTypeStringLabel = new Map<string, string>([
  [TransactionTypeString.Draw, "Draw"],
  [TransactionTypeString.Fee, "Fee"],
  [TransactionTypeString.Payment, "Payment"],
  [TransactionTypeString.BalanceTransfer, "Balance transfer"],
  [TransactionTypeString.Premium, "Premium"],
  [TransactionTypeString.Payoff, "Payoff"],
  [TransactionTypeString.Reversal, "Reversal"],
  [TransactionTypeString.BalanceAdjustment, "Balance adjustment"]
]);

export const TransactionTypeLabel = new Map<number, string>([
  [TransactionType.Draw, "Draw"],
  [TransactionType.Fee, "Fee"],
  [TransactionType.Payment, "Payment"],
  [TransactionType.BalanceTransfer, "Balance transfer"],
  [TransactionType.Premium, "Premium"],
  [TransactionType.Payoff, "Payoff"],
  [TransactionType.Reversal, "Reversal"],
  [TransactionType.BalanceAdjustment, "Balance adjustment"]
]);

export enum TransferMethod {
  ACH = 'ach',
  RTP = 'rtp',
  FedNow = 'fed-now',
  Wire = 'wire',
  Check = 'check',
  CreditCard = 'credit-card'
}

export const TransferMethodLabel = new Map<TransferMethod, string>([
  [ TransferMethod.ACH, "ACH" ],
  [ TransferMethod.RTP, "RTP" ],
  [ TransferMethod.FedNow, "FedNow" ],
  [ TransferMethod.Wire, "Wire" ],
  [ TransferMethod.Check, "Check" ],
  [ TransferMethod.CreditCard, "Credit Card" ]
]);

export enum TransferSource {
  RYNO = 'ryno',
  Client = 'client'
}

export const TransferSourceLabel = new Map<TransferSource, string>([
  [ TransferSource.RYNO, "RYNO" ],
  [ TransferSource.Client, "Client" ]
]);

export interface TransactionPreviewResponse
{
  disbursedAmount?: number;
  thirdPartyPayoffAmount?: number;
  fee?: number;
  principalAmount?: number;
  interestAmount?: number;
  newOutstandingBalance?: number;
  newAvailableFunds?: number;
  newUpcomingPaymentAmount?: number;
  newUpcomingPaymentDate?: Date;
  promotionInfo?: PromotionInfo;
}
